// export default {
//   apiKey: "AIzaSyAI0nXHlxs4yvTUyuN1ZTVxgUqma2nVvBs",
//   authDomain: "datapingpong-vue.firebaseapp.com",
//   databaseURL: "https://datapingpong-vue.firebaseio.com",
//   projectId: "datapingpong-vue",
//   storageBucket: "datapingpong-vue.appspot.com",
//   messagingSenderId: "297643774422",
//   appId: "1:297643774422:web:ca8a5d53c0dcf403"
// };
  
export default {
  apiKey: "AIzaSyAI0nXHlxs4yvTUyuN1ZTVxgUqma2nVvBs",
  authDomain: "datapingpong.com",
  databaseURL: "https://datapingpong-vue.firebaseio.com",
  projectId: "datapingpong-vue",
  storageBucket: "datapingpong-vue.appspot.com",
  messagingSenderId: "297643774422",
  appId: "1:297643774422:web:ca8a5d53c0dcf403"
};
  



//////////////////
// WEBPACK FOOTER
// ./config/firebase.config.js
// module id = null
// module chunks = 